import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import { ProductConfigurator, ProductConfig } from './ProductConfigurator';
import { useGetProductQuery } from '../../api/productApi';
import { Product } from '../../types/product';

export const ProductConfiguratorWrapper: React.FC = () => {
  const { productId } = useParams<{ productId: string }>();
  const { data: product, isLoading, error } = useGetProductQuery(productId!);

  const defaultConfig: ProductConfig = {
    type: 'fabric',
    material: '',
    color: '',
    size: '',
    quantity: 1,
    customization: '',
    dimensions: { width: 0, height: 0, depth: 0 },
    specialRequests: []
  };

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (error || !product) {
    return (
      <Box p={3}>
        <Typography variant="h6" color="error">
          Product not found or error loading product.
        </Typography>
      </Box>
    );
  }

  const productData = product as Product;

  const handleSave = (config: ProductConfig) => {
    console.log('Saving configuration:', config);
    // Handle save logic here
  };

  return (
    <ProductConfigurator
      product={productData}
      config={defaultConfig}
      onSave={handleSave}
    />
  );
}; 